/* SCANNER HEALTH STICKER (James 2026-10-10): the morning link-scanner check as a small sticker, bottom right of the
   release grid (and Links health), kept left of the right sidebar when it's open. Its verdict ("Scanner 16/19"),
   coloured green / amber / red; tap for every check (staff: Run now). A view mounts it into its own markup, so an SPA
   swap removes it with the view:  HealthSticker.mount(containerElement). Data: GET /links-health/check. */
(function () {
  'use strict';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var call = function (method, url) { return fetch(url, { method: method, credentials: 'same-origin' }).then(function (r) { return r.json(); }); };
  var box = null, docWired = false;
  function place() {
    if (!box || !document.body.contains(box) || box.hidden) return;
    var wrap = document.querySelector('.right-sidebar-wrapper'), right = 18;
    if (wrap && document.body.classList.contains('right-sidebar-open')) {
      var rect = wrap.getBoundingClientRect();
      if (rect.width > 0 && rect.left < window.innerWidth) right = Math.max(18, window.innerWidth - rect.left + 16);
    }
    box.style.right = right + 'px';
  }
  function render(res) {
    var r = res && res.result;
    if (!box) return;
    if (!r) { box.hidden = true; return; }
    box.hidden = false;
    box.classList.toggle('is-fail', r.failed > 0); box.classList.toggle('is-warn', !r.failed && (r.blocked > 0 || r.warned > 0));
    var total = r.passed + r.failed + r.blocked + r.warned;
    box.querySelector('[data-hs-chip]').textContent = 'Scanner ' + r.passed + '/' + total + (r.failed ? ' · ' + r.failed + ' failed' : '');
    var when = new Date(r.at);
    var day = when.toDateString() === new Date().toDateString() ? 'Today ' : when.toLocaleDateString() + ' ';
    box.querySelector('[data-hs-head]').innerHTML = '<span>Scanner health · ' + esc(day + when.toTimeString().slice(0, 5)) + '</span>' +
      (res.staff ? '<button type="button" class="hs-btn" data-hs-run>Run now</button>' : '');
    var rows = (r.checks || []).concat(r.ops || []);
    rows.sort(function (a, b) { var o = { fail: 0, blocked: 1, warn: 2, pass: 3 }; return o[a.status] - o[b.status]; });
    box.querySelector('[data-hs-list]').innerHTML = rows.map(function (x) {
      return '<div class="hs-row"><span class="hs-st">' + esc(x.status) + '</span><span><b>' + esc(x.name) + '</b>' + (x.status === 'pass' ? '' : '<br><span class="hs-why">' + esc(String(x.why).slice(0, 300)) + '</span>') + '</span></div>';
    }).join('');
    place();
  }
  function mount(container) {
    if (!container) return;
    container.innerHTML = '<div class="hs" data-hs hidden><button type="button" class="hs-chip" data-hs-chip aria-expanded="false"></button>' +
      '<div class="hs-pop" data-hs-pop hidden><div class="hs-head" data-hs-head></div><div data-hs-list></div></div></div>';
    box = container.querySelector('[data-hs]');
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-hs-chip]');
      if (chip) { var pop = box.querySelector('[data-hs-pop]'); pop.hidden = !pop.hidden; chip.setAttribute('aria-expanded', pop.hidden ? 'false' : 'true'); return; }
      var b = e.target.closest('[data-hs-run]'); if (!b) return;
      b.style.minWidth = b.offsetWidth + 'px'; b.disabled = true; b.textContent = '…';
      call('POST', '/links-health/check').then(render).catch(function () { b.disabled = false; b.textContent = 'Run now'; });
    });
    if (!docWired) {
      docWired = true;
      document.addEventListener('click', function (e) { if (box && document.body.contains(box) && !box.contains(e.target)) { var pop = box.querySelector('[data-hs-pop]'); if (pop) pop.hidden = true; } });
      window.addEventListener('resize', place);
      new MutationObserver(place).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    call('GET', '/links-health/check').then(render).catch(function () {});
  }
  window.HealthSticker = { mount: mount, place: place };
})();
